document.addEventListener('DOMContentLoaded', () => {
  const triggers = document.querySelectorAll('[data-drawer-trigger]');
  const drawers = document.querySelectorAll('.ingredients-mobile-drawer');
  const closeButtons = document.querySelectorAll('.drawer-close-button');
  const overlays = document.querySelectorAll(
    '.ingredients-mobile-drawer__overlay'
  );

  const closeDrawer = (drawer) => {
    drawer.classList.remove('is-visible');
    document.body.style.overflow = '';
  };


  document.body.addEventListener('click', (e) => {
    const trigger = e.target.closest('[data-drawer-trigger]');
    if (trigger && window.innerWidth < 769) {

      const ingredientTitle = trigger.getAttribute('data-ingredient-title');
      

      const drawer = Array.from(drawers).find(d => {
        const drawerTitle = d.querySelector('.drawer-content-header h2')?.textContent?.trim();
        return drawerTitle === ingredientTitle;
      });

      if (drawer) {
   
        drawers.forEach(d => {
          if (d !== drawer && d.classList.contains('is-visible')) {
            closeDrawer(d);
          }
        });
        
        drawer.classList.add('is-visible');
        document.body.style.overflow = 'hidden';
      }
    }
  });


  closeButtons.forEach((button) => {
    button.addEventListener('click', () => {
      const drawer = button.closest('.ingredients-mobile-drawer');
      closeDrawer(drawer);
    });
  });


  overlays.forEach((overlay) => {
    overlay.addEventListener('click', () => {
      const drawer = overlay.closest('.ingredients-mobile-drawer');
      closeDrawer(drawer);
    });
  });
});

function showDrawer(title) {
  const drawer = document.querySelector('.ingredients-mobile-drawer');
  if (drawer) {
    const drawerContent = drawer.querySelector('.drawer-content');
    drawerContent.textContent = title;
    document.body.style.overflow = 'hidden';
    drawer.classList.add('is-visible');
  }
}

function closeDrawer() {
  const drawer = document.querySelector('.ingredients-mobile-drawer');
  if (drawer) {
    document.body.style.overflow = '';
    drawer.classList.remove('is-visible');
  }
}
